import Cookies from 'js-cookie';
import { signIn } from 'next-auth/react';
import { useTranslations } from 'next-intl';

import GoogleSVG from '@/public/logo/google.svg';
import LogoAppleSVG from '@/public/logo/logo-apple.svg';

export default function OauthForm() {
  const t = useTranslations('Components.Form.OauthForm');
  return (
    <div className='w-full space-y-2 sm:mx-auto sm:max-w-md'>
      <button
        type='button'
        onClick={() => {
          Cookies.set('nextauth_callbackUrl', window.location.href, {
            path: '/',
            sameSite: 'lax',
          });

          signIn(
            'cognito',
            { redirect: false },
            {
              identity_provider: 'Google',
            }
          );
        }}
        className='flex w-full justify-center space-x-2 rounded bg-white-filled-default py-2 font-bold text-black-filled-default'
      >
        <p>{t('connectWithGoogle')}</p>
        <GoogleSVG />
      </button>
      <button
        type='button'
        onClick={() => {
          Cookies.set('nextauth_callbackUrl', window.location.href, {
            path: '/',
            sameSite: 'lax',
          });
          signIn(
            'cognito',
            { redirect: false },
            {
              identity_provider: 'SignInWithApple',
            }
          );
        }}
        className='flex w-full justify-center space-x-2 rounded bg-white-filled-default py-2 font-bold text-black-filled-default'
      >
        <p>{t('connectWithApple')}</p>
        <LogoAppleSVG width={32} height={32} />
      </button>
    </div>
  );
}
